import toast from 'react-hot-toast';
import { User, CreateUserRequest, HealthResponse } from '../types/api';
import { axiosInstance } from './apiClient';

const api = axiosInstance;

// Request interceptor
api.interceptors.request.use(
  config => {
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const message = error.response?.data?.message || error.message || 'An error occurred';
    toast.error(message);
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

// API methods
export const apiService = {
  // Health check
  health: async (): Promise<HealthResponse> => {
    const response = await api.get('/health');
    return response.data;
  },

  // Users
  users: {
    getAll: async (): Promise<User[]> => {
      const response = await api.get('/users');
      return response.data;
    },

    getById: async (id: string): Promise<User> => {
      const response = await api.get(`/users/${id}`);
      return response.data;
    },

    create: async (userData: CreateUserRequest): Promise<User> => {
      const response = await api.post('/users', userData);
      toast.success('User created successfully');
      return response.data;
    },

    delete: async (id: string): Promise<void> => {
      await api.delete(`/users/${id}`);
      toast.success('User deleted successfully');
    },
  },
};
